import { globalTypes } from '../types';
import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    activeFilter: defaultFilter,
});

const defaultFilter = {
    name: 'LAST_ADDED',
    label: 'Last Added',
};

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case globalTypes.INITIALIZE:
        case types.CLEAR_WISHLISTS:
            return initialState();

        case types.SET_LOADING:
            return reduceAction(state, 'loading', !!action.payload);

        case types.SET_WISHLISTS:
            return {
                ...state,
                data: { ...state.data, ...action.payload },
            };

        case types.LOAD_WISHLISTS:
            return {
                ...state,
                data: {
                    ...state.data,
                    activeFilter: action.payload ? action.payload : defaultFilter,
                },
            };
        default:
            return state;
    }
};

export default reducers;
